import { Factory } from 'rosie';

Factory.define('AppFeatures');

Factory.define('AppFeaturesLoaded')
  .attr('roleFeatures', {})
  .attr('gatekeeperFeatures', {})
  .attr('browserCapabilities', {});



// WEBPACK FOOTER //
// ./factories/app_features_factory.js